var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("VerDetalle"),
      _vm._v(" "),
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [_vm._v("business")]),
          _vm._v(" Comisión Viajes\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-tooltip",
                { attrs: { bottom: "" } },
                [
                  !_vm.filterShow
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "btn-refresh",
                          attrs: { slot: "activator", icon: "" },
                          on: {
                            click: function(v) {
                              _vm.filterShow = true
                            }
                          },
                          slot: "activator"
                        },
                        [_c("v-icon", [_vm._v("filter_list")])],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", [_vm._v("Filtros")])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-tooltip",
                { attrs: { bottom: "" } },
                [
                  _vm.filterShow
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "btn-refresh",
                          attrs: { slot: "activator", icon: "" },
                          on: {
                            click: function(v) {
                              _vm.filterShow = false
                            }
                          },
                          slot: "activator"
                        },
                        [_c("v-icon", [_vm._v("filter_list")])],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", [_vm._v("Ocultar")])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-tooltip",
                { attrs: { bottom: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-refresh",
                      attrs: { slot: "activator" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.cargaListado()
                        }
                      },
                      slot: "activator"
                    },
                    [_c("v-icon", [_vm._v("refresh")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("common.updateList")))])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _vm.filterShow
                    ? _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs2: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  "append-icon": "search",
                                  label: "Nombres",
                                  "single-line": "",
                                  "hide-details": ""
                                },
                                on: { input: _vm.filterNombres }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  "append-icon": "search",
                                  label: "Cite",
                                  "single-line": "",
                                  "hide-details": ""
                                },
                                on: { input: _vm.filterCite }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  "append-icon": "search",
                                  label: "Fecha salida",
                                  "single-line": "",
                                  "hide-details": ""
                                },
                                on: { input: _vm.filterSalida }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  "append-icon": "search",
                                  label: "Fecha retorno",
                                  "single-line": "",
                                  "hide-details": ""
                                },
                                on: { input: _vm.filterRetorno }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    [
                      _c("v-data-table", {
                        attrs: {
                          headers: _vm.headers,
                          items: _vm.rows,
                          "item-key": "cite",
                          search: _vm.filters,
                          "custom-filter": _vm.customFilter
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "headers",
                            fn: function(props) {
                              return [
                                _c(
                                  "tr",
                                  _vm._l(props.headers, function(header) {
                                    return _c("th", { key: header.text }, [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(header.text) +
                                          "\n                "
                                      )
                                    ])
                                  }),
                                  0
                                )
                              ]
                            }
                          },
                          {
                            key: "items",
                            fn: function(props) {
                              return [
                                _c("tr", [
                                  _c("td", { staticClass: "text-xs-center" }, [
                                    _vm._v(_vm._s(props.item.nombres))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-xs-center" }, [
                                    _vm._v(_vm._s(props.item.cite))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-xs-center" }, [
                                    _vm._v(_vm._s(props.item.fecha_desde))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-xs-center" }, [
                                    _vm._v(_vm._s(props.item.fecha_hasta))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { staticClass: "nowrap text-xs-center" },
                                    [
                                      _c(
                                        "v-tooltip",
                                        { attrs: { bottom: "" } },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                slot: "activator",
                                                color: "green",
                                                icon: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.verDetalleViaje(
                                                    props.item
                                                  )
                                                }
                                              },
                                              slot: "activator"
                                            },
                                            [
                                              _c("v-icon", [
                                                _vm._v("visibility")
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("span", [_vm._v("Ver registro")])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-759ede4e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-759ede4e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/comision_viaje/ListadoViajeDetalleConsulta.vue
// module id = null
// module chunks = 